<div class="as-wrapper">
  <div #toolbar class="floating-menu-toolbar">

    @if (!isDocked && !isHorizontal) {
      <div
        class="header header__vertical"
        (pointerdown)="mouseDown($event)"
        (pointermove)="mouseMove($event)"
        (pointerup)="mouseUp()"
        (dblclick)="doubleClick()">
        <span [ngClass]="{'light' : darkMode}">||||||||</span>
        <ng-container *ngTemplateOutlet="closeButton"></ng-container>
      </div>
    }

    @if (!isDocked && isHorizontal) {
      <div
        class='header header__horizontal'
        (pointerdown)="mouseDown($event)"
        (pointermove)="mouseMove($event)"
        (pointerup)="mouseUp()"
        (dblclick)="doubleClick()">
        <ng-container *ngTemplateOutlet="closeButton"></ng-container>
        <span [ngClass]="{'light' : darkMode}">||||||||</span>
      </div>
    }

    <ng-content></ng-content>

    @if (isDocked) {
      <div
        class="header header__docked"
        (mousedown)="mouseDown($event)"
        (touchstart)="mouseDown($event)"
        (mousemove)="mouseMove($event)"
        (mouseup)="mouseUp()"
        (dblclick)="doubleClick()">
        @if (isDockOpen) {
          <ng-container *ngTemplateOutlet="closeButton"></ng-container>
        }
        <i [className]="image"
        (click)="click()"></i>
      </div>
    }
  </div>
</div>

<!-- (click)="close()" -->
<ng-template #closeButton>
  <i class="fas fa-times"
    [ngClass]="{'light' : darkMode}"
    [asgClickHandler]="close"
  asgTooltip="TOOLBARS.CLOSE_TOOLBAR"></i>
</ng-template>